import { lazy } from 'react';

import type { IntlShape } from 'react-intl';

import { messages } from '../../../common/messages';

import type { AutoUpdateIntervalDropdownOption } from './types';

const StatusWorkflowStoppedIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_icon-lab-status-workflow-stopped" */ '@atlaskit/icon-lab/core/status-workflow-stopped'
		),
);

const SpeedometerRightDownIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_icon-lab-speedometer-right-down" */ '@atlaskit/icon-lab/core/speedometer-right-down'
		),
);

const SpeedometerUpIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_icon-lab-speedometer-up" */ '@atlaskit/icon-lab/core/speedometer-up'
		),
);

const SpeedometerLeftDownIcon = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_icon-lab-speedometer-left-down" */ '@atlaskit/icon-lab/core/speedometer-left-down'
		),
);

export const getAutoUpdateIntervalOptions = (
	intl: IntlShape,
): AutoUpdateIntervalDropdownOption[] => [
	{
		Icon: StatusWorkflowStoppedIcon,
		id: 'agent-managed-extension-auto-update-interval-none',
		label: intl.formatMessage(messages.noAutoUpdate),
		option: 'none',
	},
	{
		Icon: SpeedometerRightDownIcon,
		id: 'agent-managed-extension-auto-update-interval-short',
		label: intl.formatMessage(messages.updateIntervalShort),
		option: 'short',
	},
	{
		Icon: SpeedometerUpIcon,
		id: 'agent-managed-extension-auto-update-interval-medium',
		label: intl.formatMessage(messages.updateIntervalMedium),
		option: 'medium',
	},
	{
		Icon: SpeedometerLeftDownIcon,
		id: 'agent-managed-extension-auto-update-interval-long',
		label: intl.formatMessage(messages.updateIntervalLong),
		option: 'long',
	},
];
